var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2.917,
    height: 25.168,
    viewBox: "0 0 2.917 25.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1816",
    "data-name": "Group 1816",
    transform: "translate(-16.097 -7.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7461",
    "data-name": "Path 7461",
    d: "M17.537,27.6a1.113,1.113,0,0,0,1.111-1.111L18.94,9.093c0-.613-.79-1.111-1.4-1.111s-1.4.5-1.4,1.111l.286,17.395A1.113,1.113,0,0,0,17.537,27.6",
    transform: "translate(0.018 0)",
    fill: "#023f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7462",
    "data-name": "Path 7462",
    d: "M17.555,23.56a1.458,1.458,0,1,0,1.458,1.458,1.46,1.46,0,0,0-1.458-1.458",
    transform: "translate(0 6.673)",
    fill: "#023f7f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerton);
export default __webpack_public_path__ + "static/media/alerton.a55480c9cd58944ea1e89de64dcc60f9.svg";
export { ForwardRef as ReactComponent };